import Footer from '@components/common/footer'
import Navbar from '@components/common/navbar'
import { pressReleaseSeo } from '@lib/seo'
import { sanitize } from 'isomorphic-dompurify'
import { NextSeo } from 'next-seo'
import releases from '@json-data/auto-generated/press.json'

/**
 *
 * How to update the press release:
 * 1. Add the new press release data to json-data/press.json which consists of date, url, and siteName.
 * 2. cd web && yarn run:press
 * 3. This will generate a new file in json-data/auto-generated/press.json
 * 4. The new file will be used in this page to display the press releases.
 */

const Press = () => (
  <>
    <NextSeo {...pressReleaseSeo} />
    <Navbar isSticky={true} />
    <div
      className="flex flex-col items-center justify-center py-10 lg:py-20"
      style={{
        background:
          'linear-gradient(82.95deg, #BF3240 -6.56%, #7E36D9 122.43%)',
      }}
    >
      <div className="text-center lg:pt-10">
        <h1 className="text-4xl text-white font-600">
          Codingal often makes the news
        </h1>
        <h4 className="text-xl text-grey-400">
          Check out the latest news, media coverage and press releases on
          Codingal
        </h4>
      </div>
    </div>
    <div className="flex flex-col items-center justify-center py-10 space-y-5 bg-grey-100">
      {releases.map((release) => {
        return (
          <a
            href={release?.url}
            target="_blank"
            rel="noreferrer noopener"
            key={release?.url}
          >
            <div className="flex flex-col p-2 overflow-hidden bg-white rounded-md shadow-lg lg:flex-row w-80 lg:w-256 items-center">
              <div className="flex justify-center w-full h-40 overflow-hidden rounded-md lg:w-1/3 lg:h-48">
                <img
                  src={release?.image}
                  className="max-w-full max-h-full rounded-md object-contain"
                  alt={release?.title}
                  loading="lazy"
                  width={336}
                  height={192}
                />
              </div>
              <div className="flex flex-col justify-center w-full p-3 space-y-2 lg:w-2/3 lg:px-5 lg:py-0">
                <p className="text-grey-800">
                  {release?.date} &#8226; {release?.siteName}
                </p>
                <h4
                  className="text-xl leading-tight lg:text-2xl font-600 lg:leading-normal text-grey"
                  dangerouslySetInnerHTML={{
                    __html: sanitize(release?.title),
                  }}
                />
                <p className="hidden my-2 text-orange lg:block">Read more</p>
                <p className="py-3 text-center btn btn-orange lg:hidden">
                  Read more
                </p>
              </div>
            </div>
          </a>
        )
      })}
    </div>
    <Footer />
  </>
)

// TODO: Remove once getInitialProps is removed from _app.tsx
export const getStaticProps = async () => {
  return {
    props: {},
  }
}

export default Press
